/*
 * Created Date: 28-02-2024, 4:46:58 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Feb 28 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

export const workspaceAvatarUrl = '/assets/images/auth/default_avatar_workspace.png'
export const userRole = {
	admin: 'admin',
	guest: 'guest'
}
